import Icon from '../components/Icon.vue'

Icon.register({
  magic: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M224 96L240 64 272 48 240 32 224 0 208 32 176 48 208 64 224 96zM80 160L106.7 106.7 160 80 106.7 53.3 80 0 53.3 53.3 0 80 53.3 106.7 80 160zM432 288L405.3 341.3 352 368 405.3 394.7 432 448 458.7 394.7 512 368 458.7 341.3 432 288zM502.6 94.2L417.8 9.4C411.5 3.1 403.3 0 395.1 0 387 0 378.8 3.1 372.5 9.4L9.4 372.5C-3.1 385-3.1 405.3 9.4 417.8L94.2 502.6C100.5 508.9 108.7 512 116.8 512 125 512 133.2 508.9 139.5 502.6L502.6 139.5C515.1 127 515.1 106.7 502.6 94.2zM359.4 203.5L308.5 152.6 395.1 65.9 446.1 116.9 359.4 203.5z'
      }
    ]
  }
})
